import React from 'react';
import { bool, shape, string } from 'prop-types';
import FormHeadingCompact from './FormHeadingCompact';
import FormHeadingRegular from './FormHeadingRegular';

const FormHeading = ({
  title,
  subTitle,
  description,
  requiredFields,
  className,
  compact,
}) => {
  if (compact) {
    return (
      <FormHeadingCompact
        title={title}
        subTitle={subTitle}
        description={description}
        requiredFields={requiredFields}
        className={className}
      />
    );
  }
  return (
    <FormHeadingRegular
      title={title}
      subTitle={subTitle}
      description={description}
      requiredFields={requiredFields}
      className={className}
    />
  );
};

FormHeading.defaultProps = {
  requiredFields: { icon: '', text: '' },
  className: '',
  compact: false,
  title: '',
  subTitle: '',
};

FormHeading.propTypes = {
  requiredFields: shape({
    icon: string,
    message: string,
  }),
  title: string,
  subTitle: string,
  description: string.isRequired,
  className: string,
  compact: bool,
};

export default FormHeading;
